import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  // Left shape: spins while sliding in
  gsap.fromTo(".shape-right",
    { x: "-150px", rotation: 0, opacity: 0 }, 
    {
      x: "42vw",          // move toward center
      xPercent: -150,     // offset for spacing
      rotation: 385,     // spin one full circle + stop inclined (-25°)
      opacity: 1,
      duration: 3,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".section.cta",
        start: "top 80%",
        toggleActions: "play none none none"
      },
      onComplete: () => {
        // subtle floating after stopping
        gsap.to(".shape-right", {
          y: "+=15",
          duration: 3,
          ease: "sine.inOut",
          yoyo: true,
          repeat: -1
        });
      }
    }
  );

  // Right shape: spins while sliding in
  gsap.fromTo(".shape-left",
    { x: "150px", rotation: 0, opacity: 0 }, 
    {
      x: "-50vw",         // move toward center
      xPercent: 150,      // offset for spacing
      rotation: -385,      // spin one full circle + stop inclined (25°)
      opacity: 1,
      duration: 3,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".section.cta",
        start: "top 80%",
        toggleActions: "play none none none"
      },
      onComplete: () => {
        // subtle floating after stopping
        gsap.to(".shape-left", {
          y: "-=15",
          duration: 3,
          ease: "sine.inOut",
          yoyo: true,
          repeat: -1
        });
      }
    }
  );
});
